module.exports = __webpack_public_path__ + "media/images/coffre-fort-37152bee5efa18cb56d70118cc116e72.svg";